import { IAppAction, ActionType } from './Helpers';
import { toast } from 'react-toastify';
import { IErrorLog } from '../state/errorlog.state';
import i18next from 'i18next';
import LoginService from './../../services/login/login-service';
import StandardResponse from './../../models/standard-response';
import {
    IUserData,
    ILoginFormField,
    IsupportedDateAndTimeFormat,
    ILanguagePreference,
    ICurrencyDetails,
    ICurrencyFormat,
} from './../../models/login/index';
import { ConvertAbility } from 'utils/abilityConverter';
import { RawRule } from '@casl/ability';
import ability from 'ability';
import { ISupportedLanguage } from 'store/state/language.state';

export const login = (data: IUserData): IAppAction => {
    return { type: ActionType.LOGIN_REQUEST, payload: data };
};

export const userDetail = (data: IUserData) => {
    return (dispatch) => {
        if (data) {
            const abilities: RawRule[] = ConvertAbility(data.menus || []);
            ability.update(abilities);
            data.abilities = abilities;
            dispatch({ type: ActionType.FETCH_USER_DETAILS, payload: data });
        }
    };
};

export const loginAsync = (loginModel: ILoginFormField) => {
    const loginService = new LoginService();
    return function (dispatch) {
        return loginService
            .login(loginModel)
            .then(async (res: StandardResponse<IUserData>) => {
                const abilities: RawRule[] = ConvertAbility(res.Data.menus || []);
                ability.update(abilities);
                res.Data.abilities = abilities;
                await dispatch(login(res.Data));
            })
            .catch((m) => {
                toast.error(m.toString());
            })
            .finally();
    };
};

export const addError = (data: IErrorLog): IAppAction => {
    return { type: ActionType.ERROR_LOG, payload: data };
};

export const removeError = (): IAppAction => {
    return { type: ActionType.CLEAR_ERROR_LOG };
};

export const changeLanguage = (language: ISupportedLanguage | ILanguagePreference): IAppAction => {
    i18next.changeLanguage(language?.code);
    return { type: ActionType.CHANGE_LANGUAGE, payload: language };
};

export const setSupportedLanguages = (data) => {
    return { type: ActionType.SUPPORTED_LANGUAGES, payload: data };
};

export const setDefaultLanguage = (data) => {
    return { type: ActionType.DEFAULT_LANGUAGE, payload: data };
};

export const setDateTimeFormat = (dateAndTime: IsupportedDateAndTimeFormat): IAppAction => {
    return { type: ActionType.DATE_TIME_FORMAT, payload: dateAndTime };
};

export const setCurrencyFormat = (currencyFormat: ICurrencyFormat): IAppAction => {
    return { type: ActionType.CURRENCY_FORMAT, payload: currencyFormat };
};

export const setNumberFormat = (number_format: any) => {
    return { type: ActionType.NUMBER_FORMAT, payload: number_format };
};

export const setCurrencyDetails = (currency: ICurrencyDetails) => {
    return { type: ActionType.CURRENCY_DETAILS, payload: currency };
};

export const logout = () => {
    const loginService = new LoginService();
    return function (dispatch) {
        return loginService
            .logout()
            .then(async () => {
                removeError();
                await dispatch({ type: ActionType.LOGOUT_REQUEST });
            })
            .catch((m) => {
                toast.error(m.toString());
            });
    };
};
export const saveUserData = (data): IAppAction => {
    const abilities: RawRule[] = ConvertAbility(data.menus || []);
    ability.update(abilities);
    data.abilities = abilities;
    return { type: ActionType.USER_DATA, payload: data };
};

export const setCompanyName = (name: string) => {
    return { type: ActionType.COMPANY_NAME, payload: name };
};
